import { isPrerenderedPath, parseLangPrefix } from '@/modules/seo/prerenderedPaths'
import { getStoredLanguage } from './languageStorage'
import type { SupportedLanguage } from './supportedLanguages'

export function resolveInitialLanguage(): SupportedLanguage {
  if (typeof window === 'undefined') return 'en'

  const prefix = parseLangPrefix(window.location.pathname)
  if (prefix && isPrerenderedPath(window.location.pathname)) {
    return prefix.lang
  }

  const stored = getStoredLanguage()
  if (stored) return stored

  return 'en'
}
